import React from 'react';
import css from '../../../../components/MarkdownText/MarkdownText.module.css';

export const Table = (props) => (
  <table className={css.markdownTable} {...props} />
);

export const TableHead = (props) => (
  <thead className={css.markdownTableHeader} {...props} />
);

export const TableBody = (props) => (
  <tbody className={css.markdownTableBody} {...props} />
);

export const TableRow = (props) => (
  <tr className={css.markdownTableRow} {...props} />
);

export const TableHeaderCell = (props) => (
  <th className={css.markdownTableHeaderCell} {...props} />
);

export const TableCell = (props) => (
  <td className={css.markdownTableCell} {...props} />
);